export default __webpack_public_path__ + "static/media/HIP-Logo.c06e3148.png";